import isStripeID from './isStripeID';

/**
 * This used to be named isAnsweringEnhancedP1 and checked for
 * if the answeringServiceEnhanceP1Feature feature flag was in addition
 * to validating the mlsProductIds.
 */
const hasValidStripeMlsProductId = (mlsProductId?: string) =>
  Boolean(mlsProductId && isStripeID('prod', mlsProductId));

export default hasValidStripeMlsProductId;
